import { EActionTypes } from '../../actions/realtyValuation';
import { TReduxActions } from '../../types/redux/actions';
import { IDeveloperValuationState } from '../../types/developerValuation/developerValuationState';
import { preparePricesFilters } from './utils/preparePricesFilters';

export const defaultDeveloperValuationState: IDeveloperValuationState = {
  isFetching: false,
  isError: false,
  developerValuation: null,
  pricesFiltersState: {
    buildingClass: [],
    period: 'allTime',
    roomCount: [],
    regionId: -1,
  },
};

export function developerValuationReducer(
  state = defaultDeveloperValuationState,
  action: TReduxActions,
): IDeveloperValuationState {
  switch (action.type) {
    case EActionTypes.Request:
      return {
        ...state,
        isFetching: true,
      };

    case EActionTypes.Success:
      return {
        ...state,
        isFetching: false,
        isError: false,
        developerValuation: action.payload?.developerValuation || state.developerValuation,
      };

    case EActionTypes.Failure:
      return {
        ...state,
        isFetching: false,
        isError: true,
      };

    case EActionTypes.SetPriceFilter:
      return {
        ...state,
        pricesFiltersState: {
          ...state.pricesFiltersState,
          [action.payload.filterName]: preparePricesFilters(action.payload)[action.payload.filterName](),
        },
      };

    default:
      return state;
  }
}
